import { render, staticRenderFns } from "./SchoolInvoice.vue?vue&type=template&id=6eeb4376&scoped=true&"
import script from "./SchoolInvoice.vue?vue&type=script&lang=ts&"
export * from "./SchoolInvoice.vue?vue&type=script&lang=ts&"
import style0 from "./SchoolInvoice.vue?vue&type=style&index=0&id=6eeb4376&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eeb4376",
  null
  
)

export default component.exports